module.exports = __webpack_public_path__ + "img/gift.bb84b94e.png";